// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/laser-directed-light.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/laser-directed-light/laser-directed-light.js';

mount([g0]);
